module.exports = __webpack_public_path__ + "static/media/bg5m.2cb57188.jpg";